<div class="entete">
  <h1 [ngStyle]="{'color':'#47BB9C'}">Accueil</h1>
</div>
<div class="corps">
  <h1> Bienvenue dans l'outil d'administration référentiel des restos du coeur.</h1>
</div>
